import React, { useState } from 'react';
import Menu from '../Menu'; // Assuming you have a Menu component

const LoginForClient = () => {
  const [/* socket */, setSocket] = useState(null);
  const [merchantName, setMerchantName] = useState("M4");
  const [key, setKey] = useState("key4");
  const [posName, setPosName] = useState("7");
  const [msg, setMsg] = useState("Test connection");
  const [messageLog, setMessageLog] = useState([]);

  const handleLogin = () => {
    const ws = new WebSocket("ws://157.90.147.8:9500");
    setSocket(ws);

    ws.onopen = () => {
      console.log("WebSocket connected");
      const data = {
        Action: "login",
        MerchantName: merchantName,
        Key: key,
        PosName: posName,
        Msg: msg,
      };
      ws.send(JSON.stringify(data));
      setMessageLog((prev) => [...prev, { type: "sent", data }]);
    };

    ws.onmessage = (event) => {
      const parsedData = JSON.parse(event.data);
      setMessageLog((prev) => [...prev, { type: "received", data: parsedData }]);
    };

    ws.onerror = (error) => {
      console.error("websocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket closed");
    };
  };

  const clearLog = () => setMessageLog([]);

  return (
    <>
      <Menu /> {/* Sidebar menu included */}
      <div className="content-wrapper" style={{ padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div
            style={{
              backgroundColor: '#fff',
              padding: '2rem',
              borderRadius: '8px',
              width: '48%',
            }}
          >
            <h4>Login to WebSocket</h4>
            <div className="form-group">
              <label>Merchant Name</label>
              <input
                type="text"
                className="form-control"
                value={merchantName}
                onChange={(e) => setMerchantName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Key</label>
              <input
                type="text"
                className="form-control"
                value={key}
                onChange={(e) => setKey(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>POS Name</label>
              <input
                type="text"
                className="form-control"
                value={posName}
                onChange={(e) => setPosName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <input
                type="text"
                className="form-control"
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
              />
            </div>

            <button className="btn btn-primary" onClick={handleLogin}>
              Login
            </button>
          </div>

          {/* Message Log Box */}
          <div
            style={{
              backgroundColor: '#fff',
              padding: '2rem',
              borderRadius: '8px',
              width: '48%',
            }}
          >
            <h4>Message Log</h4>
            <ul style={{ maxHeight: '400px', overflowY: 'scroll' }}>
              {messageLog.map((log, index) => (
                <li key={index}>
                  <strong>{log.type === 'sent' ? 'Sent' : 'Received'}:</strong>{' '}
                  <pre>{JSON.stringify(log.data, null, 2)}</pre>
                </li>
              ))}
            </ul>

            {/* Clear Log Button */}
            <button
              className="btn btn-danger"
              onClick={clearLog}
              style={{ width: '100%', marginTop: '10px' }}
            >
              Clear Log
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginForClient;
